import { render, staticRenderFns } from "./AllOrders.vue?vue&type=template&id=4f7142e2"
import script from "./AllOrders.vue?vue&type=script&lang=js"
export * from "./AllOrders.vue?vue&type=script&lang=js"
import style0 from "./AllOrders.vue?vue&type=style&index=0&id=4f7142e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports